export type MaterialIconFamily = 'filled' | 'outlined' | 'twotone' | 'rounded' | 'sharp';

export type MaterialIconSize = 's' | 'm' | 'l' | 'xl';
